import React from 'react';
import { Container as Box, ContainerPartial } from './styles';
import AfyaPay from '../../../images/afya-icon.png';

export default function Container(props){
    return(
        <>
            {props.partial && (
                <ContainerPartial>
                    <img src={AfyaPay} alt='logo AfyaPay'/>
                    <main>
                        {props.children}
                    </main>
                </ContainerPartial>
            )}
            {!props.partial && (
                <Box>
                    <img src={AfyaPay} alt='logo AfyaPay'/>
                    <main>
                        {props.children}
                    </main>
                </Box>
            )}
        </>
    )
}
